export interface IAnalyticsOptions {
  app_name: string;
  app_version: string;
}

export enum TrackingActionNamesEnum {
  app_loaded = 'app_loaded',
  assigned = 'assigned',
  button_tapped = 'button_tapped',
  chart_tapped = 'chart_tapped',
  card_form_changed = 'card_form_changed',
  card_presented = 'card_presented',
  cell_tapped = 'cell_tapped',
  checkbox_checked = 'checkbox_checked',
  checkbox_unchecked = 'checkbox_unchecked',
  completed = 'completed',
  deleted = 'deleted',
  dropdown_tapped = 'dropdown_tapped',
  dropdown_selected = 'dropdown_selected',
  error = 'error',
  error_invoked = 'error_invoked',
  failed = 'failed',
  field_tapped = 'field_tapped',
  input_assigned = 'input_assigned',
  input_assigned_bulk = 'input_assigned_bulk',
  input_tapped = 'input_tapped',
  input_unassigned = 'input_unassigned',
  input_changed = 'input_changed',
  opened = 'opened',
  presented = 'presented',
  rendered = 'rendered',
  radio_tapped = 'radio_tapped',
  result_tapped = 'result_tapped',
  saved = 'saved',
  searched = 'searched',
  signed_out = 'signed_out',
  sign_in_started = 'sign_in_started',
  sign_in_completed = 'sign_in_completed',
  sign_in_failed = 'sign_in_failed',
  sign_up_started = 'sign_up_started',
  sign_up_completed = 'sign_up_completed',
  sign_up_failed = 'sign_up_failed',
  scrolled = 'scrolled',
  started = 'started',
  submitted = 'submitted',
  success = 'success',
  tapped = 'tapped',
  tab_tapped = 'tab_tapped',
  toggle_tapped = 'toggle_tapped',
  trial_purchased = 'trial_purchased',
  upload_completed = 'upload_completed',
  upload_failed = 'upload_failed',
  viewed = 'viewed',
}

export interface ITrackingObject {
  name: string;
  properties: ITrackingProperties;
}

export interface ITrackingAction {
  name: string;
  properties: ITrackingProperties;
  // DropdownSelectedTrackingAction has this property
  // and it is being called on webapp
  setValue?: (value: any) => any;
}

export interface ITrackingProperties {
  [prop: string]: string | number | boolean | ITrackingProperties;
}
